module.exports = __webpack_public_path__ + "static/media/01_design_agd-stocker-pao.8af30377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/01_design_agd-stocker-pao.jpg
// module id = 234
// module chunks = 0